import FeatureDrawer from "../helpers/FeatureDrawer";
import MapElement from "./MapElement";

import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';

import { Fill, RegularShape, Stroke, Style } from 'ol/style';

export default class MapRPRProduction extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent);
    }

    drawLayer(data, projection) {
        var featureDrawer = new FeatureDrawer(projection, this.mapModel.projection)

        var features = [];
        var style = new Style({
            stroke: new Stroke({
                color: "red",
                width: 0.1
            }),
            fill: new Fill({ color: [255, 0, 0, 0.5] })
        });
        var source = new VectorSource();
        this.layer = new VectorLayer({
            source: source,
            style: style,
        });

        for (const timepositionlogId in data) {
            var timepositionlog = data[timepositionlogId];
            var prevLeft = null;
            var prevRight = null;
            var currentLeft = null;
            var currentRight = null;

            for (let i = 0; i < timepositionlog.length; i++) {
                const value = timepositionlog[i];
                currentLeft = [value.drumLeft_X, value.drumLeft_Y];
                currentRight = [value.drumRight_X, value.drumRight_Y];

                if (prevLeft != null && prevRight != null) {

                    var coordinates = [[
                        currentLeft,
                        currentRight,
                        prevRight,
                        prevLeft,
                        currentLeft
                    ]];

                    var feature = featureDrawer.drawFeature({ type: "POLYGON", coordinates: coordinates })
                    feature.set('millingInfo', value);
                    features.push(feature);
                }


                prevLeft = currentLeft;
                prevRight = currentRight;
            }
        }

        source.addFeatures(features);

        this.parent.layer.getLayers().push(this.layer);

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }
    }
}